const CALLING_CODES = new Set([
  '1', '7', '20', '27', '30', '31', '32', '33', '34', '36', '39', '40', '41', '43', '44', '45', '46', '47',
  '48', '49', '51', '52', '53', '54', '55', '56', '57', '58', '60', '61', '62', '63', '64', '65', '66', '81',
  '82', '84', '86', '90', '91', '92', '93', '94', '95', '98', '211', '212', '213', '216', '218', '220', '221',
  '222', '223', '224', '225', '226', '227', '228', '229', '230', '231', '232', '233', '234', '235', '236',
  '237', '238', '239', '240', '241', '242', '243', '244', '245', '246', '248', '249', '250', '251', '252',
  '253', '254', '255', '256', '257', '258', '260', '261', '262', '263', '264', '265', '266', '267', '268',
  '269', '290', '291', '297', '298', '299', '350', '351', '352', '353', '354', '355', '356', '357', '358',
  '359', '370', '371', '372', '373', '374', '375', '376', '377', '378', '380', '381', '382', '383', '385',
  '386', '387', '389', '420', '421', '423', '500', '501', '502', '503', '504', '505', '506', '507', '508',
  '509', '590', '591', '592', '593', '594', '595', '596', '597', '598', '599', '670', '672', '673', '674',
  '675', '676', '677', '678', '679', '680', '681', '682', '683', '685', '686', '687', '688', '689', '690',
  '691', '692', '850', '852', '853', '855', '856', '880', '886', '960', '961', '962', '963', '964', '965',
  '966', '967', '968', '970', '971', '972', '973', '974', '975', '976', '977', '992', '993', '994', '995',
  '996', '998'
]);

export function formatPhoneNumber(value: string): string {
  const raw = (value || '').trim();
  if (!raw) return '-';

  let digits = raw.replace(/[^\d+]/g, '');
  if (digits.startsWith('00')) digits = `+${digits.slice(2)}`;
  if (!digits.startsWith('+')) digits = `+${digits.replace(/\D/g, '')}`;

  const onlyDigits = digits.slice(1);
  if (!onlyDigits) return raw;

  const countryCode = detectCountryCode(onlyDigits);
  const local = onlyDigits.slice(countryCode.length);
  if (!local) return `+${countryCode}`;
  return `+${countryCode} ${groupLocalNumber(local)}`;
}

function detectCountryCode(digits: string): string {
  for (let len = 3; len >= 1; len -= 1) {
    const candidate = digits.slice(0, len);
    if (CALLING_CODES.has(candidate)) return candidate;
  }
  return digits.slice(0, Math.min(3, digits.length));
}

function groupLocalNumber(local: string): string {
  if (local.length <= 4) return local;
  if (local.length === 5) return `${local.slice(0, 2)} ${local.slice(2)}`;
  if (local.length === 6) return `${local.slice(0, 3)} ${local.slice(3)}`;
  if (local.length === 7) return `${local.slice(0, 3)} ${local.slice(3)}`;
  if (local.length === 8) return `${local.slice(0, 4)} ${local.slice(4)}`;
  if (local.length === 9) return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
  if (local.length === 10) return `${local.slice(0, 5)} ${local.slice(5)}`;
  return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
}
